import React from "react";
import logo from "assets/img/Logo_Coopap_Icono.jpg";
import { Button, Card, Col, Container, Row } from "react-bootstrap";
import styles from "./CentralElementLayout.module.scss";

function CentralElementLayout(props) {
    return (
        <div className={"d-flex flex-column min-vh-100 " + styles['main-container']}>
            {/* Yellow Background */}
            <Container className={"d-flex justify-content-center mt-5"}>
                {props.children}
            </Container>

            {/* Footer */}
            <footer className={styles.footer + " text-center p-3 mt-auto"}>
                <p className="text-white mb-0">© {new Date().getFullYear()} Coopap. Todos los derechos reservados.</p>
            </footer>
        </div>
    );
}

export default CentralElementLayout;